import React, { useState } from 'react'
import styles from './NoticeMain.module.scss'
import { NoticeTab } from './NoticeTab'
import { FaqTab } from './FaqTab'
import { InquiryTab } from './InquiryTab'
import { MainHeader } from '../../layout/Header/MainHeader'
import { MainFooter } from '../../layout/MainFooter'

export const NoticeMain = () => {
	const [activeTab, setActiveTab] = useState('NoticeTab')

	const tabs = [
		{ id: 'NoticeTab', label: '공지사항' },
		{ id: 'FaqTab', label: 'FAQ' },
		{ id: 'InquiryTab', label: '문의하기' },
	]

	return (
		<div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
			<MainHeader />
			<div className={styles.noticeWrapper}>
				<div className={styles.header}>
					<span className={styles.title}>
						{tabs.find((tab) => tab.id === activeTab)?.label}
					</span>

					<div className={styles.buttonBox} role="tablist" aria-label="공지사항 탭">
						{tabs.map((tab) => (
							<button
								key={tab.id}
								role="tab"
								type="button"
								id={`${tab.id}-tab`}
								className={
									activeTab === tab.id
										? `${styles.buttonOption} ${styles.active}`
										: styles.buttonOption
								}
								aria-selected={activeTab === tab.id}
								aria-controls={`${tab.id}-panel`}
								tabIndex={-1}
								onClick={() => setActiveTab(tab.id)}>
								{tab.label}
							</button>
						))}
					</div>
				</div>

				{/* 탭 내용 */}
				<div className={styles.tabContent}>
					{activeTab === 'NoticeTab' && <NoticeTab />}
					{activeTab === 'FaqTab' && <FaqTab />}
					{activeTab === 'InquiryTab' && <InquiryTab />}
				</div>
			</div>
			<MainFooter />
		</div>
	)
}
